import { Component } from '@angular/core';

import { Subject } from 'rxjs';

import { JobsFilters } from '../entities/jobs-filters.entity';

@Component({
	selector: 'jobs-supervision',
	templateUrl: 'jobs-supervision.html',
	// styleUrls: ['jobs-supervision.css']
})
export class JobsSupervisionComponent {
	filters$= new Subject<JobsFilters>();

	constructor(
	) {
	}

	/////////////////////////////////////
	// Gestion des actions utilisateur //
	/////////////////////////////////////
	
	onFilterRequest(filters: JobsFilters) {
		this.filters$.next(filters);
	}
}